const removeExtension = (fileName) =>
  fileName.split(".").slice(0, -1).join(".");

export default removeExtension;
